 import { InjectionToken } from '@angular/core'

export const BASE_PATH = new InjectionToken<string>('basePath')
export const APP_PATH = new InjectionToken<string>('AppPath')
export const SERVER_BASE_PATH = new InjectionToken<string>('SsrBasePath')
export const CLINICA_WEB_COOKIE_VALUE = new InjectionToken<string>('')
